var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6116 6L16.6496 17.4475V20.8062H15.3504V17.4475L11.3885 6H5V26H9.29016V16.0338L7.57586 10.3484L8.79673 9.9026L14.3681 25.9995H17.6319L23.2033 9.9026L24.4241 10.3484L22.7099 16.0338V26H27V6H20.6116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeWhite);
export default __webpack_public_path__ + "static/media/mode-white.18e96a0fce6d2c50992754cbddc7287c.svg";
export { ForwardRef as ReactComponent };